export default __webpack_public_path__ + "static/media/a3.4afcec81.JPG";